// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"49":"75ec0193203f54f85cd3","96":"93e9ed15d0749eef9033","631":"8fd6377d92f7e689f4fb","797":"6786bd083ecd9b92d3a5"}[chunkId] + ".js";
};